import './info-badge.scss';
